<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container modal-container-80" @click="dontClose">
          <div class="modal-body m-0" style="overflow-y: auto;" :style="{maxHeight: getMaxHeightClient() + 'px'}">
            <div slot="formcontent" style="margin: 0px 20px 0px 20px;">
              <b-row class="panel-heading">
                <b-col cols="12" class="formTitleBlock">
                  <h4 class="content-block labelAccordionForm">
                    <i class="fa-light fa-file-code mr-2" style="font-size: 20px"></i>
                    {{ 'Document' }}
                  </h4>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <iframe :src="data.src" :height="80 * maxHeight / 100 + 'px'" width="100%"></iframe>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="modal-footer">
            <b-col lg="2" sm="3" cols="6" class="p-0 m-0">
              <b-button variant="primary" @click="downloadFile()">{{ $t('common.download') }}</b-button>
            </b-col>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { downloadFileWithDefinedHeaders } from '@/helpers/download'

export default {
  name: 'DocumentViewer',
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      maxHeight: undefined
    }
  },
  created () {
    this.maxHeight = document.querySelector('body').clientHeight
    window.addEventListener('resize', this.changeMaxHeightClient)
    window.addEventListener('click', this.handleClick)
  },
  destroyed () {
    window.removeEventListener('resize', this.changeMaxHeightClient)
  },
  methods: {
    changeMaxHeightClient () {
      this.maxHeight = document.querySelector('body').clientHeight
      document.querySelector('.modal-container').setAttribute('style', 'overflow-y:auto;max-height:' + maxHeight + 'px')
    },
    dontClose (e) {
      if (!e.target.closest('.modal-action')) {
        e.stopPropagation()
      }
    },
    downloadFile () {
      downloadFileWithDefinedHeaders(this, this.data.filename, this.data.src)
    },
    getMaxHeightClient () {
      return document.querySelector('body').clientHeight
    },
    handleClick (e) {
      if (e.target.closest('.modal-mask')) {
        this.$emit('close')
      }
    }
  }
}
</script>
<style scoped>
</style>
